import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";

import { SelfServeContext } from "../types";
import { getSelectedBrandOrderFromLocalStorage } from "../utils/localStorage";

const INITIAL_STATE: SelfServeContext = {
  tree: {},
  selectedBrandOrder: getSelectedBrandOrderFromLocalStorage(),
};

const {
  useStore: useSelfServeContextStore,
  Provider: SelfServeContextProvider,
} = createContextStore<SelfServeContext>(INITIAL_STATE);

export { SelfServeContextProvider, useSelfServeContextStore };
